import React from 'react';
import { QuoteIcon, StarIcon } from 'lucide-react';
const reviews = [{
  quote: 'The team knew exactly when to slow the pace and when to let us take in the moment. It felt less like joining a trek and more like being welcomed into a place they genuinely care for.',
  name: 'Amelia R.',
  trip: 'Manaslu Circuit Trek'
}, {
  quote: 'Everything was thoughtfully handled, from our first briefing in Kathmandu to the decisions made around weather on the pass. The small group made the whole journey feel calm and personal.',
  name: 'Daniel K.',
  trip: 'Private Manaslu Journey'
}, {
  quote: 'Manaslu was extraordinary, but it was the local stories, lodge hosts, and our guide’s quiet confidence that made the experience stay with us long after the trail.',
  name: 'Sofia & Mark L.',
  trip: 'Tsum Valley & Manaslu'
}];
export function CustomerReviews() {
  return <section className="w-full bg-[#efe9dc] py-20 text-[#1d2d2a] sm:py-28" aria-labelledby="reviews-title" data-id="element-54" data-mp="27cfea8t1n9gc">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-10" data-id="element-55" data-mp="1ihfeepg8y4us">
        <header className="mx-auto max-w-3xl text-center" data-id="element-56" data-mp="1dfzr0qqljm98">
          <p className="eyebrow" data-id="element-57" data-mp="18hy9wbcqdx0e">From our guests</p>
          <h2 id="reviews-title" className="mt-4 font-display text-4xl leading-tight sm:text-5xl" data-id="element-58" data-mp="18ipukr4siabw">
            The journey, in their words.
          </h2>
        </header>

        <div className="mt-12 grid gap-8 border-t border-[#c8c1af] pt-10 md:grid-cols-3" data-id="element-59" data-mp="2163wl3nchw2v">
          {reviews.map(review => <figure key={review.name} className="flex flex-col" data-id="element-60" data-mp="1w9va156tj0lo">
              <QuoteIcon className="h-6 w-6 text-[#6D5A39]" aria-hidden="true" data-id="element-61" data-mp="1rf977qesygd7" />
              <blockquote className="mt-5 font-display text-2xl leading-snug text-[#1d2d2a]" data-id="element-62" data-mp="1nde88skcgf2l">
                “{review.quote}”
              </blockquote>
              <figcaption className="mt-7 border-t border-[#c8c1af] pt-4" data-id="element-63" data-mp="2f5bw5xnf767l">
                <div className="flex gap-1 text-[#A48C5A]" aria-label="Five-star review" data-id="element-64" data-mp="d8b5qju99ld2">
                  {Array.from({
                length: 5
              }, (_, index) => <StarIcon key={index} className="h-3.5 w-3.5 fill-current" aria-hidden="true" data-id="element-65" data-mp="8husp0uck1r8" />)}
                </div>
                <p className="mt-4 text-sm font-bold text-[#1d2d2a]" data-id="element-66" data-mp="3vo5amz1bc356">
                  {review.name}
                </p>
                <p className="mt-1 text-xs font-bold uppercase tracking-[0.16em] text-[#6D5A39]" data-id="element-67" data-mp="3grxqfypwn1pw">
                  {review.trip}
                </p>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}